import { Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

export class InputBase {
  @Input() form: FormGroup;
  @Input() name: string;
  @Input() label: string;
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/shared/form/input-base.ts